import Settings from "../../../constants/Settings";
import ApiHelper from "../../../shared/ApiHelper";

const PhotoApiHelpers = {
    getImage: async (observationId: number, imageName: string): Promise<any> => {
        return (await ApiHelper.getPhoto(`${Settings.HabitatUrl}/observations/${observationId}/image?image=${imageName}`, true)).data;
    },
};

export default PhotoApiHelpers